export const getHeaderAlign = (cellData: {
  numeric?: boolean;
  center?: boolean;
}) => {
  if (cellData.numeric) {
    return 'right';
  }
  if (cellData.center) {
    return 'center';
  }
  return 'left';
};
